<template>
  <v-container fill-height pa-0>
    <v-container fill-height pa-0 v-show="step===1">
      <v-row no-gutters justify="center" class="pt-8">
        <v-col cols="12" align="center">
          <span class="title" v-if="job.public.address.address1===undefined">Where is the job located?</span>
          <span class="title" v-else>Confirm Location?</span>
        </v-col>
      </v-row>

      <v-row no-gutters justify="center">
        <v-col cols="12" md="8">

          <v-row justify="center">
            <v-col cols="12" align="center">
              <v-list-item>
                <v-list-item-content class="pb-3 pt-3">
                  <div :class="` custom-input v-input v-input--is-label-active v-input--is-dirty v-input--dense ${$vuetify.theme.dark?'theme--dark':'theme--light'} v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined`">
                    <div class="v-input__control" style="height:40px">
                      <div :class="`v-input__slot `">
                        <div class="v-input__prepend-inner">
                          <v-icon color="primary">map</v-icon>
                        </div>
                        <gmap-autocomplete ref="search" :class="`v-text-field__slot pt-4 pl-2`" :label="$language.addJob['Job Address']" :placeholder="$language.addJob['Enter Job Address']" @place_changed="getAddressData">
                        </gmap-autocomplete>
                        <v-btn text icon color="primary lighten-1" class="mx-0 pr-0 mt-0 pt-1" @click="clear">
                          <v-icon medium class="pr-0">cancel</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                  <small v-if="noLocation" class="error--text pt-0 mt-0" style="padding-left: 12px">A location is required</small>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
          <v-row no-gutters justify="center" v-if="job.public.address.address1!==undefined">

            <v-col cols="12" md="6" v-show="false">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-list-item>
                    <v-list-item-content>
                      <v-text-field outlined dense hide-details flat label="Address 1" v-model="job.public.address.address1" readonly></v-text-field>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="5">
                  <v-list-item class="pl-4 px-1">
                    <v-list-item-content>
                      <v-text-field outlined dense hide-details flat label="City" v-model="job.public.address.city" readonly></v-text-field>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="3">
                  <v-list-item class="px-1">
                    <v-list-item-content>
                      <v-text-field outlined dense hide-details flat label="State" v-model="job.public.address.state" readonly></v-text-field>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="4">
                  <v-list-item class="pr-4 px-1">
                    <v-list-item-content>
                      <v-text-field outlined dense hide-details flat label="Zip" v-model="job.public.address.zip" readonly></v-text-field>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="pt-0">
              <gmap-map :key="mapIndex" :center="{lat:job.public.location[0],lng:job.public.location[1]}" :zoom="12" :style="`height: 250px`" v-if="job.public.address.address1!==undefined" class="mt-3 mx-3">
                <gmap-marker :position="{lat:job.public.location[0],lng:job.public.location[1]}" @click="center={lat:job.public.location[0],lng:job.public.location[1]}" />
              </gmap-map>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row no-gutters justify="center" class="px-4">

        <v-col cols="12" md="8">
          <v-btn color="primary" style="height:60px" @click="()=>{$vuetify.goTo(0);step = 2;logStep(2)}" block large :disabled="job.public.address.formatted_address===undefined">Continue</v-btn>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12">

        </v-col>
      </v-row>

    </v-container>

    <v-container fill-height pa-0 v-show="step===2">

      <v-row no-gutters class="mt-8" align="center">
        <v-col cols="12" align="center">
          <span class="title pb-12">A picture is worth a thousand words.</span>

        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="12" md="8" align="center">
          <v-card outlined>
            <v-row no-gutters class="pa-2" justify="center">

              <template v-for="(item,index) in job.public.pictures">
                <v-col cols="4" :key="index" class="px-1">
                  <v-img contain :src="item.url">
                    <v-container fill-height>
                      <v-row>
                        <v-col cols="12" justfy="center" align="center">
                          <v-icon size="40" color="error lighten-3" @click="removeBlob(index)">delete</v-icon>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-img>
                </v-col>
              </template>

              <v-col cols="4" justify="center" align="center">
                <v-container fill-height @click="addPhotoDialog = true">
                  <v-row>
                    <v-col cols="12" justify="center" align="center">
                      <v-btn icon>
                        <v-icon x-large>add_a_photo</v-icon>
                      </v-btn>
                      <br>
                      <span class="caption">{{$language.addJob['Add Photo']}}</span>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

      </v-row>

      <v-row no-gutters justify="center" class="px-4">

        <v-col cols="12" md="8">
          <v-btn color="primary" style="height:60px" @click="()=>{$vuetify.goTo(0);step = 3;logStep(3)}" block large>Continue</v-btn>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12">

        </v-col>
      </v-row>

    </v-container>

    <v-container fill-height pa-0 v-show="step===3">

      <v-row class="pt-8">
        <v-col cols="12" align="center">
          <span class="title">Lets get a few more details about the work.</span>

        </v-col>
      </v-row>
      <v-row no-gutters justify="center">
        <v-col cols="12" md="8" align="center">

          <v-row no-gutters>
            <v-col cols="12" v-show="!fromReg">
              <v-list-item>
                <v-list-item-content class="mb-0 pb-0">
                  <v-select dense ref="category" v-model="job.public.category" outlined :label="$language.addJob['Select a category']" :items="categories" item-value="_key" item-text="_key" :rules="requiredRule">
                    <template v-slot:prepend-inner>
                      <v-icon class="pr-2">category</v-icon>
                    </template>
                    <template slot="item" slot-scope="{ item }">
                      <img :src="require(`@/assets/${item._key}.svg`)" class="mr-3" :alt="item._key"> {{$language.settings.Categories[item._key]}}
                    </template>
                  </v-select>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12">
              <v-list-item>
                <v-list-item-content class="mb-0 pb-0">
                  <v-text-field ref="title" v-model="job.public.title" dense outlined flat :rules="requiredRule" :label="$language.addJob['Job title']">
                    <template v-slot:prepend-inner>
                      <v-icon class="pr-2">short_text</v-icon>
                    </template>
                  </v-text-field>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12">
              <v-list-item>
                <v-list-item-content class="mb-0 pb-0">
                  <v-textarea ref="description" v-model="job.public.jobDesc" outlined flat auto-grow rows="3" :rules="descRules" :label="$language.addJob['Job description']">
                    <template v-slot:prepend-inner>
                      <v-icon class="pr-2">notes</v-icon>
                    </template>
                  </v-textarea>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row justify="center" class="px-4">

        <v-col cols="12" md="8">
          <v-btn color="primary" style="height:60px" @click="()=>{$vuetify.goTo(0);step = 4;logStep(4)}" block large :disabled="((job.public||{}).jobDesc).length===0||((job.public||{}).title).length===0">Continue</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">

        </v-col>
      </v-row>

    </v-container>

    <v-container fill-height pa-0 v-show="step===4">
      <v-row class="pt-8" justify="center">
        <v-col cols="12" align="center">
          <span class="title ">When do you want this help?</span>

        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" align="center">

          <v-row no-gutters v-if="!fixedTime">
            <v-row no-gutters justify="center">
              <v-col cols="12" md="8" align="center">
                <v-col cols="12">
                  <v-btn block large color="success" @click="()=>{asap = true;step=5;logStep(5)}">ASAP</v-btn>
                </v-col>

                <v-col cols="12">
                  <v-btn block large color="success" @click="()=>{fixedTime=true;asap=false}">Fix time</v-btn>
                </v-col>
              </v-col>
            </v-row>

          </v-row>

          <v-row no-gutters class=" pb-8" v-if="fixedTime" justify="center">

            <v-col cols="12" md="8" class="pl-4" align="center" :key="timeIndex">
              <v-row no-gutters justify="space-around" align="end">
                <v-col cols="12" align="center">
                  <v-date-picker v-model="job.public.startDate" no-title scrollable :min="nowDate" full-width>
                  </v-date-picker>
                </v-col>
                <v-col cols="6" class="pt-6">
                  Start
                  <vue-timepicker format="h:mm A" v-model="job.public.startTime" @change="checkTime()" minute-interval="15" :input-class="$vuetify.theme.dark?'dark':''" drop-direction="up">
                    <template v-slot:dropdownButton>&#x02263;</template>
                    <template v-slot:label>start</template>
                  </vue-timepicker>
                </v-col>

                <v-col cols="6" class="pt-6">
                  End
                  <vue-timepicker format="h:mm A" v-model="job.public.endTime" @change="checkTime()" minute-interval="15" :input-class="$vuetify.theme.dark?'dark':''" drop-direction="up">
                    <template v-slot:dropdownButton>&#x02263;</template>
                  </vue-timepicker>
                </v-col>
              </v-row>
            </v-col>

          </v-row>
        </v-col>
        <v-row justify="center" class="px-4" v-if="fixedTime">

          <v-col cols="12">
            <v-btn color="primary" style="height:60px" @click="()=>{$vuetify.goTo(0);step = 5;logStep(5)}" block large>Continue</v-btn>
          </v-col>
        </v-row>
      </v-row>
      <v-row>
        <v-col cols="12">

        </v-col>
      </v-row>

    </v-container>

    <v-container fill-height pa-0 v-show="step===5">
      <v-row class="pt-8" justify="center">
        <v-col cols="12" align="center">
          <span class="title ">How much do you want to pay?</span>

        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" align="center">

          <v-row no-gutters justify="center">
            <v-col cols="12" md="8">
              <v-list-item v-if="isRateTypeSelected('Fixed')">
                <v-list-item-content>
                  <v-text-field ref="fixedCost" v-model="job.public.fixedCost" type="Number" min="1" outlined dense flat :rules="numberRules" :label="$language.addJob['Fixed Total ($)']">
                    <template v-slot:prepend-inner>
                      <v-icon class="pr-2">fa-money-bill</v-icon>
                    </template>

                  </v-text-field>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12" md="8" align="center">
              <v-btn color="primary" text @click="()=>{job.public.fixedCost = null;job.public.bid=true;this.step=6;logStep(6)}">Not sure, open for bids.</v-btn>
            </v-col>
          </v-row>

        </v-col>

      </v-row>
      <v-row justify="center" class="px-4">

        <v-col cols="12" md="8" align="center">
          <v-btn color="primary" style="height:60px" @click="()=>{$vuetify.goTo(0);step = 6;logStep(6)}" block large :disabled="job.public.fixedCost === null">Continue</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">

        </v-col>
      </v-row>

    </v-container>

    <v-container fill-height pa-0 v-show="step===6">
      <v-row class="pt-8" justify="center">
        <v-col cols="12" align="center">
          <span class="title pb-12">How are you going to pay for it?</span>

        </v-col>
        <v-col cols="12" align="center">
          <span class="subtitle pb-12">Don't worry, we wont charge you until the job is done.</span>

        </v-col>

      </v-row>
      <v-row justify="center">
        <v-col cols="12" md="8" align="center">

          <v-layout column justify-center align-center v-if="(userProfile.stripeCustomerAccount||{}).processing">
            <v-progress-circular indeterminate :size="70" :width="7" color="primary"></v-progress-circular>
          </v-layout>
          <v-list v-if="!(userProfile.stripeCustomerAccount||{}).processing &&hasSources">
            <v-list-item v-for="item in sources" :key="item.id">
              <v-list-item-avatar>
                <v-icon large :color="`${item.id === (userProfile.stripeCustomerAccount||{}).default_source?'primary':''}`">credit_card</v-icon>
              </v-list-item-avatar>

              <v-list-item-content :class="`${item.id === (userProfile.stripeCustomerAccount||{}).default_source?'primary--text':''}`">
                <v-list-item-title>
                  {{item.brand}} {{ $language.settings['ending'] }} ···· {{item.last4}} <span v-if="item.id === (userProfile.stripeCustomerAccount||{}).default_source" :class="`orange--text  text--darken-4 ${ $vuetify.breakpoint.xs ? 'caption' : 'body-1'}`">(default)</span>
                </v-list-item-title>

              </v-list-item-content>

              <v-list-item-action>
                <template>
                  <div class="text-xs-center">
                    <v-menu>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on">more_vert</v-icon>
                      </template>
                      <v-list>
                        <v-list-item @click="setNewDefault(item)" v-if="item.id !== (userProfile.stripeCustomerAccount||{}).default_source">
                          <v-list-item-title>Set as Default</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="deleteSource(item)">
                          <v-list-item-title>Delete</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </template>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-row>
            <v-col cols="12" align="center">
              <v-btn text small color="primary" @click="openPaymentDialog=true" v-if="hasSources">{{ $language.settings['add payment method'] }}</v-btn>
              <v-btn text color="red " @click="openPaymentDialog=true" v-else>
                <v-icon class="pr-4" v-if="!(userProfile.stripeCustomerAccount||{}).default_source">warning</v-icon><span class="bold">{{ $language.settings['add payment method'] }}</span>
              </v-btn>
            </v-col>
          </v-row>

          <v-dialog v-model="openPaymentDialog" :overlay="true" max-width="320" transition="dialog-transition">
            <AddStripe :is-cust="hasSources" @open="openPaymentDialog = false"></AddStripe>
          </v-dialog>

        </v-col>
      </v-row>
      <v-row justify="center" class="px-4">

        <v-col cols="12" md="8" align="center">
          <v-btn color="primary" style="height:60px" @click="()=>{$vuetify.goTo(0);step = 7;logStep('7_creditCard')}" block large :disabled="!hasSources">Continue</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">

        </v-col>
      </v-row>

    </v-container>

    <v-container fill-height pa-0 v-show="step===7">
      <v-row class="pt-8" justify="center">
        <v-col cols="12" align="center">
          <span class="title">Everything look good?</span>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" md="8" align="center">

          <v-row no-gutters justify="center">
            <v-col cols="12" align="center">
              <v-row no-gutters class="pa-4" justify="center" align="center">
                <v-col cols="12" justify="center" align="center">
                  <v-card outlined>
                    <v-row no-gutters class="pa-2" align="center" justify="center">

                      <template v-for="(item,index) in job.public.pictures">
                        <v-col cols="4" :key="index" class="px-1">
                          <v-img contain :src="item.url">
                            <v-container fill-height>
                              <v-row>
                                <v-col cols="12" justfy="center" align="center">
                                  <v-icon size="40" color="error lighten-3" @click="removeBlob(index)">delete</v-icon>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-img>
                        </v-col>
                      </template>

                      <v-col cols="4" justify="center" align="center">
                        <v-container fill-height @click="addPhotoDialog = true">
                          <v-row>
                            <v-col cols="12" justify="center" align="center">
                              <v-btn icon>
                                <v-icon x-large>add_a_photo</v-icon>
                              </v-btn>
                              <br>
                              <span class="caption">{{$language.addJob['Add Photo']}}</span>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col cols="12" sm="4">
                  <v-list-item>
                    <v-list-item-content class="mb-0 pb-0">
                      <v-select dense ref="category" hide-details v-model="job.public.category" outlined :label="$language.addJob['Select a category']" :items="categories" item-value="_key" item-text="_key" :rules="requiredRule">
                        <template v-slot:prepend-inner>
                          <v-icon class="pr-2">category</v-icon>
                        </template>
                        <template slot="item" slot-scope="{ item }">
                          <img :src="require(`@/assets/${item._key}.svg`)" class="mr-3" :alt="item._key"> {{$language.settings.Categories[item._key]}}
                        </template>
                      </v-select>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" sm="8">
                  <v-list-item>
                    <v-list-item-content class="mb-0 pb-0">
                      <v-text-field ref="title" hide-details v-model="job.public.title" dense outlined flat :rules="requiredRule" :label="$language.addJob['Job title']">
                        <template v-slot:prepend-inner>
                          <v-icon class="pr-2">short_text</v-icon>
                        </template>
                      </v-text-field>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12">
                  <v-list-item>
                    <v-list-item-content class="mb-0 pb-0">
                      <v-textarea ref="description" hide-details v-model="job.public.jobDesc" outlined flat auto-grow rows="3" :rules="descRules" :label="$language.addJob['Job description']">
                        <template v-slot:prepend-inner>
                          <v-icon class="pr-2">notes</v-icon>
                        </template>
                      </v-textarea>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" md="4">
                  <v-list-item>
                    <v-list-item-content class="mb-0 pb-0">
                      <v-text-field hide-details v-if="job.public.fixedCost!==null" ref="fixedCost" v-model="job.public.fixedCost" type="Number" min="1" outlined dense flat :rules="numberRules" :label="$language.addJob['Fixed Total ($)']">
                        <template v-slot:prepend-inner>
                          <v-icon class="pr-2">fa-money-bill</v-icon>
                        </template>

                      </v-text-field>
                      <v-text-field hide-details v-if="job.public.fixedCost===null" readonly v-model="$language.addJob['Bid']" outlined dense flat :label="$language.addJob['Bid']">
                        <template v-slot:prepend-inner>
                          <v-icon class="pr-2">fa-money-bill</v-icon>
                        </template>

                      </v-text-field>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" md="8">
                  <v-list-item>
                    <v-list-item-content class="mb-0 pb-0">

                      <v-text-field hide-details readonly outlined dense flat v-model="start" :label="$language.addJob['Start Date']">
                        <template v-slot:prepend-inner>
                          <v-icon class="pr-2 ">fa-clock</v-icon>

                        </template>

                      </v-text-field>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12">
                  <gmap-map :key="mapIndex" :center="{lat:job.public.location[0],lng:job.public.location[1]}" :zoom="12" :style="`height: 176px`" v-if="job.public.address.address1!==undefined" class="mt-3 mx-3">
                    <gmap-marker :position="{lat:job.public.location[0],lng:job.public.location[1]}" @click="center={lat:job.public.location[0],lng:job.public.location[1]}" />
                  </gmap-map>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

        </v-col>
      </v-row>
      <v-row justify="center" class="px-4">

        <v-col cols="12" md="8" align="center">
          <v-btn color="primary" style="height:60px" @click="()=>{completeSetup();logStep('8_completed')}" block large>Continue</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">

        </v-col>
      </v-row>

    </v-container>

    <v-dialog v-model="addPhotoDialog" persistent :max-width="$vuetify.breakpoint.smAndDown ? 270 : 330">
      <v-card>
        <v-row>
          <v-col cols="12" justify="center" align="center">
            <croppa :key="myKey" ref="myCroppa" :width="$vuetify.breakpoint.smAndDown ? 250  : 300" :height="$vuetify.breakpoint.smAndDown ? 250 : 300" :placeholder="$language.registration['Add a photo']" :placeholder-font-size="22" :disabled="false" :prevent-white-space="true" :show-remove-button="true" :accept="'image/*'" @new-image-drawn="detectFiles" @file-choose="initial = false">
            </croppa>
          </v-col>
          <v-col cols="12" align="center">
            <v-btn fab small class="ma-1" color="primary" @click="rotatePhoto(-1)">
              <v-icon large>rotate_left</v-icon>
            </v-btn>
            <v-btn fab small class="ma-1" color="primary" @click="rotatePhoto(1)">
              <v-icon large>rotate_right</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row no-gutters align="center" justify="space-around" class="px-2">
            <v-col cols="5">
              <v-btn text @click.native="addPhotoDialog = false" block large color="primary">Cancel</v-btn>
            </v-col>
            <v-col cols="5">
              <v-btn @click="generateBlob" color="primary" block large :disabled="!uploadReady">Upload</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>

</template>

<script>
import {
  mapState
} from 'vuex'
import moment from 'moment'
import { RRule } from 'rrule'
import VueTimepicker from 'vue2-timepicker'
import AddStripe from '@/components/common/AddStripe'
const fb = require('@/services/firebaseConfig.js')
export default {
  props: ['editJob', 'isHefe', 'summaryView', 'status', 'hasStarted', 'publicView', 'fromReg', 'addBack'],
  components: {
    VueTimepicker, AddStripe
  },
  data () {
    return {
      e6: 4,
      step: 1,
      openPaymentDialog: false,
      fixedTime: false,
      asap: false,
      showCroppa: false,
      noLocation: false,
      noImage: false,
      loading: false,
      invite: false,
      invitedWorkers: [],
      snackbar: {
        show: false,
        message: '',
        status: 'success'
      },
      paymentExplanation: false,
      validForm: false,
      validation: {
        title: true,
        description: true,
        rateType: true,
        workers: true,
        fixedCost: true,
        rate: true,
        hours: true
      },
      initial: true,
      addPhotoDialog: false,
      myKey: 0,
      uploading: false,
      uploadEnd: false,
      progressUpload: 0,
      fileName: '',
      uploadTask: '',
      dialog: '',
      job: {
        public: {
          bid: false,
          phone: null,
          pictures: [],
          public: true,
          status: 'Draft',
          category: '',
          title: '',
          jobDesc: '',
          rateType: 'Fixed',
          rateTypeText: this.$language.addJob['rateTypeText'][1],
          days: null,
          workers: 1,
          hours: null,
          rate: 10,
          fixedCost: null,
          location: [],
          startDate: new Date(moment().add(-1, 'days')).toISOString().slice(0, 10),
          endDate: new Date(moment().add(-1, 'days')).toISOString().slice(0, 10),
          contractEndDate: new Date(moment().add(1, 'month')).toISOString().slice(0, 10),
          startTime: {
            h: moment().format('h'),
            mm: '00',
            A: moment().format('A') },
          endTime: {
            h: moment().add(60, 'minutes').format('h'),
            mm: '00',
            A: moment().add(60, 'minutes').format('A') },
          address: {
            url: null
          },
          repeat: false,
          occ: {
            interval: 1,
            type: 'Weeks',
            color: 'primary'
          }
        },
        mlmReferral: []
      },
      address: '',
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      modal1: false,
      modal2: false,
      menu3: false,
      menu4: false,
      menu5: false,
      requiredRule: [
        (v) => (v && v.length < 100) || 'Required field'
      ],
      descRules: [
        (v) => (v && (v || '').length <= 1000) || this.$language.validations['Description should be less than 1000 characters']
      ],
      numberRules: [
        (v) => (/[0-9]|\./).test(v) || this.$language.validations['Only numbers allowed'],
        (v) => (v && v > 0 && v <= 1000000) || this.$language.validations['Invalid value']
      ],
      nowDate: new Date(moment().subtract(1, 'days')).toISOString().slice(0, 10),
      croppaDialog: false,
      index: 0,
      filePreview: {
        img: '',
        aspect: 1,
        x: 0,
        y: 0
      },
      showPreview: false,
      myCroppa: {},
      showMap: false,
      mapIndex: 1,
      imgIndex: 2,
      timeIndex: 0,
      customRepeatDialog: false,
      showEndDate: false,
      dayToggle: [],
      monthToggle: 0,
      uploadReady: false,
      colors: ['primary', 'blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
      names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party']
    }
  },
  computed: {
    ...mapState(['userProfile', 'currentUser', 'categories']),
    timeFromNow () {
      return moment(`${this.job.public.startDate}T${(this.job.public.startTime || {}).h}.${(this.job.public.startTime || {}).mm}${(this.job.public.startTime || {}).A}`, ['YYYY-MM-DD HH.mm a'])
        .fromNow()
    },
    hasStripe () {
      return (((this.userProfile || {}).stripeCustomerAccount || {}).id || false)
    },
    hasSources () {
      return (((this.userProfile || {}).stripeCustomerAccount || {}).sources || {}).data !== undefined
    },
    weekOfMonth () {
      var a = moment(this.job.public.startDate)
      var c = Math.ceil(a.date() / 7)
      return c
    },
    dayOfMonth () {
      var a = moment(this.job.public.startDate)
      var c = a.date()
      return c
    },
    compoundProperty () {
      return [this.job.public.startDate, this.job.public.endDate, this.job.public.endTime, this.job.public.endDate, this.job.public.contractEndDate].join()
    },
    sources () {
      return (((this.userProfile || {}).stripeCustomerAccount || {}).sources || {}).data || {}
    },
    start () {
      if (this.asap) {
        return ' ASAP'
      } else {
        return ` ${this.formatShortDate(this.job.public.startDate)} @ ${this.job.public.startTime.h}:${this.job.public.startTime.mm} ${this.job.public.startTime.A}`
      }
    }
  },
  methods: {
    logStep (step) {
      fb.analytics.logEvent(`hefe_campaign_step_${step}`)
    },
    completeSetup () {
      this.addJob()
      this.$emit('completeRegistration')
    },
    setNewDefault (item) {
      item.date = new Date()
      var updates = {}
      updates[`user/${this.currentUser.uid}/profile/stripeCustomerAccount/setNewDefault`] = item
      updates[`user/${this.currentUser.uid}/profile/stripeCustomerAccount/processing`] = true
      fb.database.ref().update(updates)
    },
    deleteSource (item) {
      item.date = new Date()
      var updates = {}
      updates[`user/${this.currentUser.uid}/profile/stripeCustomerAccount/deleteSource`] = item
      updates[`user/${this.currentUser.uid}/profile/stripeCustomerAccount/processing`] = true
      fb.database.ref().update(updates)
    },

    handleEmit (data) {
      this.edit()
      this.$nextTick(() => {
        this.$emit(data)
      })
    },
    async get () {
      this.setSchedule().then(result => {
        // console.log(result)
      })
    },
    async setSchedule () {
      var rule, startTime, endTime, eachOccMin
      startTime = moment(`${this.job.public.startTime.h}:${this.job.public.startTime.mm} ${this.job.public.startTime.A}`, ['h:mm A'])
      endTime = moment(`${this.job.public.endTime.h}:${this.job.public.endTime.mm} ${this.job.public.endTime.A}`, ['h:mm A'])
      var dtstart = new Date(Date.UTC(moment(this.job.public.startDate).year(), moment(this.job.public.startDate).month(), moment(this.job.public.startDate).date(), moment(startTime).hours(), moment(startTime).minutes()))
      var until = new Date(Date.UTC(moment(this.job.public.contractEndDate).year(), moment(this.job.public.contractEndDate).month(), moment(this.job.public.contractEndDate).date() + 1))
      var untilNoRep = new Date(Date.UTC(moment(this.job.public.startDate).year(), moment(this.job.public.startDate).month(), moment(this.job.public.startDate).date() + 1))
      eachOccMin = moment(`${endTime}:00`).diff(moment(`${startTime}:00`), 'minutes')

      switch (this.job.public.repeat) {
        case false:
          this.job.public.occ.interval = 1
          rule = new RRule({
            interval: parseInt(this.job.public.occ.interval),
            dtstart: dtstart,
            until: untilNoRep
          })
          this.job.public.contractEndDate = untilNoRep
          // console.log('finish non-repeat')
          break

        case true:
          var freq
          switch (this.job.public.occ.type) {
            case 'Days':
              freq = RRule.DAILY

              rule = new RRule({
                freq: freq,
                interval: parseInt(this.job.public.occ.interval),
                dtstart: dtstart,
                until: until
              })
              // console.log('finish daily-repeat')

              break
            case 'Weeks':

              var tog = this.dayToggle.map(k => {
                switch (k) {
                  case 0:
                    return RRule.SU
                  case 1:
                    return RRule.MO
                  case 2:
                    return RRule.TU
                  case 3:
                    return RRule.WE
                  case 4:
                    return RRule.TH
                  case 5:
                    return RRule.FR
                  case 6:
                    return RRule.SA
                  default:
                    break
                }
              })
              freq = RRule.WEEKLY
              rule = new RRule({
                freq: freq,
                byweekday: tog,
                wkst: RRule.SU,
                interval: parseInt(this.job.public.occ.interval),
                dtstart: dtstart,
                until: until
              })
              // console.log('finish weekly-repeat')
              this.job.public.dayToggle = this.dayToggle

              break
            case 'Months':
              freq = RRule.MONTHLY

              if (this.monthToggle === 0) {
                rule = new RRule({
                  freq: freq,
                  interval: parseInt(this.job.public.occ.interval),
                  bymonthday: this.dayOfMonth,
                  dtstart: dtstart,
                  until: until
                })
              } else {
                var dow
                switch (moment(this.job.public.startDate).day()) {
                  case 1:
                    dow = [RRule.MO]
                    break
                  case 2:
                    dow = [RRule.TU]
                    break
                  case 3:
                    dow = [RRule.WE]
                    break
                  case 4:
                    dow = [RRule.TH]
                    break
                  case 5:
                    dow = [RRule.FR]
                    break
                  case 6:
                    dow = [RRule.SA]
                    break
                  case 0:
                    dow = [RRule.SU]
                    break
                  default:
                    break
                }

                rule = new RRule({
                  freq: freq,
                  interval: parseInt(this.job.public.occ.interval),
                  bysetpos: parseInt(this.weekOfMonth),
                  byweekday: dow,
                  dtstart: dtstart,
                  until: until
                })
              }
              // console.log('finish monthly-repeat')

              break
            case 'Years':
              freq = RRule.YEARLY
              rule = new RRule({
                freq: freq,
                interval: parseInt(this.job.public.occ.interval),
                dtstart: dtstart,
                until: until
              })
              // console.log('finish yearly-repeat')

              break
            default:
              break
          }
          break
        default:
          break
      }
      var occList = rule.all()
      occList = occList.map(k => {
        return moment(k).set({ h: moment(occList[0]).hour(), m: moment(occList[0]).minute() })
      })

      var events = []
      occList.map(k => {
        const timeOffset = (new Date()).getTimezoneOffset()
        k = moment(k).add(timeOffset, 'minutes')
        events.push({
          name: this.job.public.title,
          start: new Date(k),
          end: new Date(moment(k).add(eachOccMin, 'minutes')),
          timed: true
        })
      })
      // console.log(events)
      this.job.public.hours = (eachOccMin / 60).toFixed(1)
      this.job.public.schedule = events
      this.job.public.scheduleText = rule.toText()
      this.events = []
      this.events = events
      return events
    },
    handleCloseRepeatDialog () {
      this.job.public.repeat = this.$language.addJob['Does not repeat']
      this.customRepeatDialog = false
    },
    handleCroppaSelect () {
      this.myCroppa.chooseFile()
    },
    handleCroppaClose () {
      this.showPreview = this.myCroppa.img !== null ? 1 : 0
      this.index += this.index
      this.job.public.picture = null
      this.imgIndex += this.imgIndex
      this.croppaDialog = false
    },
    isRateTypeSelected (option) {
      // This could have been done with an object with text and value, filter by the value but show the text. I wanted to try doing it this way.
      let original = ['Hourly', 'Fixed']
      return original.indexOf(option) === this.$language.addJob['rateType'].indexOf(this.job.public.rateType)
    },

    onlyNumber (val) {
      return val.replace(/[^0-9]/g, '')
    },
    detectFiles () {
      this.uploadReady = true
    },
    rotatePhoto (dir) {
      this.$refs.myCroppa.rotate(dir)
    },
    generateBlob () {
      var blob = this.$refs.myCroppa.generateDataUrl('image/jpeg', 0.8)

      this.job.public.pictures = this.job.public.pictures !== undefined ? this.job.public.pictures : []
      this.job.public.pictures.push({
        url: blob
      })
      this.addPhotoDialog = false
      this.$refs.myCroppa.remove()
    },
    removeBlob (index) {
      this.job.public.pictures.splice(index, 1)
    },
    upload (key) {
      return new Promise((resolve, reject) => {
        this.$refs.myCroppa.generateBlob(
          async (blob) => {
            this.fileName = blob.name
            this.uploading = true
            let uploadedImage = await fb.storage.ref(`jobs/images/${key}/profile_photo`).put(blob)
            let imageSrc = await uploadedImage.ref.getDownloadURL()
            resolve(imageSrc)
          },
          'image/jpeg'
        )
      })
    },

    blurValidate (ref) {
      this.validation[ref] = this.$refs[ref].validate()
    },

    async addJob (type) {
      this.loading = true
      this.noImage = false
      this.noLocation = false
      let sched = await this.setSchedule()
      if (this.job.public.bid) {
        this.job.public.fixedCost = 1
        this.job.public.rate = 1
      }
      if (this.job.public.location.length > 0) {
        var newKey = await fb.database.ref().child(`jobs`).push().key
        var mesKey = await fb.database.ref().child(`jobs/${newKey}/messages`).push().key

        this.job.public._key = newKey
        this.job.public.dayToggle = this.dayToggle
        this.job.public.hiredWorkers = 0
        this.job.public.createdBy = this.currentUser.uid
        this.job.public.hefeAvatar = this.userProfile.public.photoURL
        this.job.public.phone = this.userProfile.public.mobilePhone
        this.job.public.creationDate = new Date()
        this.job.public.updatedDate = new Date()
        this.job.public.hefeName = this.userProfile.public.name
        this.job.public.numberOfApplicants = 0
        this.job.public.hefeRating = this.userProfile.public.rating || -1
        this.job.mlmReferral = this.userProfile.mlm ? this.userProfile.mlm : null

        var jobRef = {
          '_key': newKey,
          'category': this.job.public.category,
          'title': this.job.public.title,
          'jobDesc': this.job.public.jobDesc,
          'status': 'Draft',
          'createdBy': this.currentUser.uid,
          'hefeName': this.userProfile.public.name,
          'hefeRating': this.userProfile.public.rating || -1,
          'creationDate': new Date(),
          'updatedDate': new Date(),
          'startTime': this.job.public.startTime,
          'endTime': this.job.public.endTime,
          'startDate': this.job.public.startDate,
          'contractEndDate': this.job.public.contractEndDate,
          'bid': this.job.public.bid,
          'location': this.job.public.location,
          'numberOfApplicants': 0,
          'schedule': sched,
          'pictures': this.job.public.pictures,
          'rateTypeText': this.job.public.rateTypeText
        }
        if (!this.job.public.bid) {
          this.job.public.workers = this.job.public.rateType === 'Fixed' ? 1 : parseInt(this.job.public.workers)
          this.job.public.compensation = this.isRateTypeSelected('Hourly') ? this.job.public.rate : this.job.public.fixedCost
          jobRef.rateType = this.job.public.rateType
          jobRef.compensation = this.job.public.compensation
          jobRef.hours = this.isRateTypeSelected('Hourly') ? this.job.public.hours : -1
        } else {
          this.job.public.workers = 1
          this.job.public.compensation = this.isRateTypeSelected('Hourly') ? this.job.public.rate : this.job.public.fixedCost
          jobRef.rateType = this.job.public.rateType
          jobRef.compensation = this.job.public.compensation
          jobRef.hours = this.isRateTypeSelected('Hourly') ? this.job.public.hours : -1
        }
        if (type === 'Draft') {
          this.job.public.status = 'Draft'
          jobRef.status = 'Draft'
        } else {
          if (this.job.public.public) {
            this.job.public.status = 'Published-Public'
            jobRef.status = 'Published-Public'
            fb.geoFireApp.set(newKey, this.job.public.location)
          } else {
            this.job.public.status = 'Published-Private'
            jobRef.status = 'Published-Private'
          }
        }

        this.job.payments = {
          'senderStripeId': this.userProfile.stripeCustomerAccount.id
        }

        this.job.messages = {
          'All': {}
        }
        this.job.messages.All[mesKey] = {
          messageText: this.$language.addJob['Welcome to the group chat...'],
          profileId: this.currentUser.uid,
          avatar: this.userProfile.public.photoURL,
          timeStamp: new Date()
        }

        var updates = {}
        updates[`/user/${this.currentUser.uid}/jobs/${newKey}`] = jobRef
        updates[`/jobs/${newKey}`] = this.job
        await fb.database.ref().update(updates)

        this.loading = false
        this.$refs.addJobForm.reset()
        this.$nextTick(function () {
          this.job = {
            public: {
              bid: true,
              pictures: [],
              public: true,
              status: 'Draft',
              category: '',
              title: '',
              jobDesc: '',
              rateType: 'Fixed',
              rateTypeText: this.$language.addJob['rateTypeText'][1],
              days: null,
              workers: null,
              hours: null,
              fixedCost: null,
              location: [],
              startDate: new Date(moment()).toISOString().slice(0, 10),
              endDate: new Date(moment()).toISOString().slice(0, 10),
              contractEndDate: new Date(moment().add(1, 'month')).toISOString().slice(0, 10),
              startTime: {
                h: moment().format('h'),
                mm: '00',
                A: moment().format('A') },
              endTime: {
                h: moment().add(60, 'minutes').format('h'),
                mm: '00',
                A: moment().add(60, 'minutes').format('A') },
              address: {
                url: null
              },
              repeat: false,
              occ: {
                interval: 1,
                type: this.$language.addJob['Days']
              }
            },
            mlmReferral: []
          }
        })

        this.showPreview = false
        this.showCroppa = false
        this.myCroppa = {}
        this.$refs.search.$el.value = null
        this.$emit('simple-close')
        this.$emit('close', {
          window: 'job-add',
          show: true,
          message: this.$language.addJob['Job created!'],
          job: newKey
        })
        if (!this.fromReg) {
          this.$nextTick(() => {
            this.loading = false
            if (this.$vuetify.breakpoint.lgAndUp) {
              this.$router.push(`/hefe/job-details/${newKey}?tab=Summary`)
            } else {
              this.$router.push(`/hefe/job-details/${newKey}?tab=Applicants`)
            }
          })
        }
      } else {
        if (this.job.public.location.length === 0) {
          this.noLocation = true
        }
        this.loading = false
        this.snackbar.message = this.$language.addJob['Missing required information']
        this.snackbar.status = 'error'
        this.snackbar.show = true
      }
    },

    async edit () {
      this.loading = true
      this.noImage = false
      this.noLocation = false

      if (this.job.public.location.length > 0) {
        var updates = {}
        var updatedDate = new Date()
        this.job.public.updatedDate = updatedDate

        if (this.job.public.status !== 'Draft') {
          if (this.job.public.public) {
            await fb.geoFireApp.set(this.job.public._key, this.job.public.location)
          } else {
            var updates2 = {}
            updates2[`/geofire/${this.job.public._key}/`] = null
            await fb.database.ref().update(updates2)
          }
        }
        let updatedSched = await this.setSchedule()
        // job ref is the one used in the obrero list items
        var jobRef = {
          '_key': this.job.public._key,
          'category': this.job.public.category,
          'title': this.job.public.title,
          'jobDesc': this.job.public.jobDesc,
          'status': this.job.public.status,
          'createdBy': this.currentUser.uid,
          'hefeName': this.userProfile.public.name,
          'hefeRating': this.userProfile.public.rating || -1,
          'creationDate': new Date(),
          'updatedDate': new Date(),
          'location': this.job.public.location,
          'startTime': this.job.public.startTime,
          'endTime': this.job.public.endTime,
          'startDate': this.job.public.startDate,
          'contractEndDate': this.job.public.contractEndDate,
          'schedule': updatedSched,
          'pictures': this.job.public.pictures || [],
          'bid': this.job.public.bid,
          'numberOfApplicants': this.job.public.numberOfApplicants
        }

        this.job.public.dayToggle = this.dayToggle
        this.job.public.phone = this.userProfile.public.mobilePhone

        this.job.public.hefeName = this.userProfile.public.name
        this.job.public.hefeRating = this.userProfile.public.rating || -1
        if (!this.job.public.bid) {
          this.job.public.workers = this.job.public.rateType === 'Fixed' ? 1 : parseInt(this.job.public.workers)
          this.job.public.compensation = this.isRateTypeSelected('Hourly') ? this.job.public.rate : this.job.public.fixedCost
          jobRef.rateType = this.job.public.rateType
          jobRef.compensation = this.job.public.compensation
          jobRef.hours = this.isRateTypeSelected('Hourly') ? this.job.public.hours : -1
        }
        if (this.job.public.applicants !== undefined) {
          Object.keys(this.job.public.applicants).map(k => {
            updates[`/user/${k}/jobs/${this.job.public._key}/category`] = this.job.public.category
            updates[`/user/${k}/jobs/${this.job.public._key}/title`] = this.job.public.title
            updates[`/user/${k}/jobs/${this.job.public._key}/jobDesc`] = this.job.public.jobDesc
            updates[`/user/${k}/jobs/${this.job.public._key}/startTime`] = this.job.public.startTime
            updates[`/user/${k}/jobs/${this.job.public._key}/startDate`] = this.job.public.startDate
            updates[`/user/${k}/jobs/${this.job.public._key}/location`] = this.job.public.location
            updates[`/user/${k}/jobs/${this.job.public._key}/category`] = this.job.public.category
            updates[`/user/${k}/jobs/${this.job.public._key}/schedule`] = updatedSched
            updates[`/user/${k}/jobs/${this.job.public._key}/pictures`] = this.job.public.pictures || []
            if (!this.job.public.bid) {
              updates[`/user/${k}/jobs/${this.job.public._key}/rateType`] = this.job.public.rateType
              updates[`/user/${k}/jobs/${this.job.public._key}/hours`] = this.isRateTypeSelected('Hourly') ? this.job.public.hours : -1
              updates[`/user/${k}/jobs/${this.job.public._key}/compensation`] = this.isRateTypeSelected('Hourly') ? this.job.public.rate : this.job.public.fixedCost
            }
          })
        }
        let sched = await this.setSchedule()
        console.log(sched)
        updates[`/jobs/${this.job.public._key}`] = this.job
        updates[`/user/${this.currentUser.uid}/jobs/${this.job.public._key}`] = jobRef
        await fb.database.ref().update(updates)
        this.snackbar.message = this.$language.addJob['Job edited successfully!']
        this.snackbar.status = 'success'
        this.snackbar.show = true
        this.loading = false
      } else {
        if (!this.job.public.picture) {
          this.noImage = true
        }
        if (this.job.public.location.length === 0) {
          this.noLocation = true
        }
        this.loading = false
        this.snackbar.message = this.$language.addJob['Missing required information']
        this.snackbar.status = 'error'
        this.snackbar.show = true
      }
    },

    clear () {
      this.job.public.location = []
      this.job.public.address = {}
      console.log(this.$refs.search.$el.value)
      this.$refs.search.$el.value = null
    },
    getAddressData: function (addressData, placeResultData, id) {
      var components = {}
      addressData.address_components.map(k => {
        components[k.types[0]] = k.short_name
      })
      this.job.public.address = {}
      this.job.public.address.url = addressData.url
      this.job.public.address.address1 = `${components.street_number || ''} ${components.route || ''}`
      this.job.public.address.city = components.locality || ''
      this.job.public.address.state = components.administrative_area_level_1 || ''
      this.job.public.address.zip = components.postal_code || ''
      this.job.public.address.html = addressData.adr_address || ''
      this.job.public.address.formatted_address = addressData.formatted_address || ''
      this.job.public.location = [(addressData.geometry.location.lat() || 0), (addressData.geometry.location.lng() || 0)]
      this.showMap = true
      this.mapIndex += this.mapIndex
      this.index += this.index
    },
    rnd (a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a
    },
    changeColor (color) {
      var updates = {}
      this.job.public.occ.color = color
      if (this.job.public.schedule) {
        Object.keys(this.job.public.schedule).map(k => {
          this.job.public.schedule[k].color = color
        })
        updates[`/user/${this.currentUser.uid}/jobs/${this.job.public._key}/schedule`] = this.job.public.schedule
        updates[`/jobs/${this.job.public._key}/public/schedule`] = this.job.public.schedule
        updates[`/jobs/${this.job.public._key}/public/occ/color`] = color
        fb.database.ref().update(updates)
      }
    },
    dayOfWeek (val) {
      if (!val) {
        return '-'
      }
      switch (moment(val).day()) {
        case 1:
          return this.$language.addJob['Monday']
        case 2:
          return this.$language.addJob['Tuesday']
        case 3:
          return this.$language.addJob['Wednesday']
        case 4:
          return this.$language.addJob['Thursday']
        case 5:
          return this.$language.addJob['Friday']
        case 6:
          return this.$language.addJob['Saturday']
        case 0:
          return this.$language.addJob['Sunday']
        default:
          break
      }
      return moment(val).day()
    },
    nth (val) {
      if (!val) {
        return '-'
      }
      switch (Math.ceil(moment(val).date() / 7)) {
        case 1:
          return this.$language.addJob['1st']
        case 2:
          return this.$language.addJob['2nd']
        case 3:
          return this.$language.addJob['3rd']
        case 4:
          return this.$language.addJob['4th']
        case 5:
          return this.$language.addJob['5th']
        default:
          break
      }
      return moment(val).day()
    },
    checkTime () {
      if (((this.job.public || {}).startDate || false) && ((this.job.public || {}).startTime || false)) {
        var start = moment(`${this.job.public.startDate} ${this.job.public.startTime.h}:${this.job.public.startTime.mm} ${this.job.public.startTime.A}`, ['YYYY-MM-DD HH.mm a'])
        var end = moment(`${this.job.public.startDate} ${this.job.public.endTime.h}:${this.job.public.endTime.mm} ${this.job.public.endTime.A}`, ['YYYY-MM-DD HH.mm a'])
        if (start >= end) {
          var newEnd = moment(`${this.job.public.startDate} ${this.job.public.startTime.h}:${this.job.public.startTime.mm} ${this.job.public.startTime.A}`, ['YYYY-MM-DD HH.mm a']).add(1, 'hour')
          this.job.public.endTime = {
            h: newEnd.format('h'),
            mm: newEnd.format('mm'),
            A: newEnd.format('A')
          }
          this.job.public.hours = (newEnd.diff(start, 'minutes') / 60)
        } else {
          this.job.public.hours = (end.diff(start, 'minutes') / 60)
        }
      }
      this.setSchedule()
    },
    formatShortDate (val) {
      if (!val) {
        return '-'
      }
      return moment(val).format('MMM Do')
    }
  },
  watch: {
    addBack () {
      console.log(this.step)
      if (this.step === 1) {
        this.$emit('back')
      } else {
        this.step -= 1
      }
    },
    tab () {
      this.index += this.index
    },

    editJob () {
      this.$nextTick(() => {
        this.job = this.editJob
        this.job.applicants = this.job.applicants ? this.job.applicants : null
        this.dayToggle = this.job.public.dayToggle ? this.job.public.dayToggle : []
        if (this.$refs.search) {
          this.$refs.search.$el.value = this.job.public.address.formatted_address
        }
      })
      if (this.$refs.myCroppa) {
        this.$refs.myCroppa.refresh()
      }
    },

    // 'myCroppa.img': function (val) {
    //   this.showPreview = this.myCroppa.img === null ? 0 : 1
    //   this.index += this.index
    //   this.imgIndex += this.imgIndex
    //   this.job.public.picture = null
    // },
    'job.public.repeat': function (val) {
      if (val === 'Custom...' || val === 'Personalizado...') {
        this.customRepeatDialog = true
        this.showEndDate = false
        this.job.public.endDate = this.job.public.startDate
      }
      if (val === this.$language.addJob['Does not repeat']) {
        this.showEndDate = false
      } else {
        this.showEndDate = true
      }
      this.$nextTick(() => {
        this.job.public.contractEndDate = new Date(moment().add(1, 'month')).toISOString().slice(0, 10)
      })
    },
    'compoundProperty': function () {
      var start = moment(`${this.job.public.startDate}T${moment(`${this.job.public.startTime.h}:${this.job.public.startTime.mm} ${this.job.public.startTime.A}`, ['h:mm A']).format('HH:mm')}:00`)
      var end = moment(`${this.job.public.endDate}T${moment(`${this.job.public.endTime.h}:${this.job.public.endTime.mm} ${this.job.public.endTime.A}`, ['h:mm A']).format('HH:mm')}:00`)
      this.job.public.endDate = start.diff(end, 'minutes') > 0 ? this.job.public.startDate : this.job.public.endDate

      this.job.public.contractEndDate = moment(`${this.job.public.contractEndDate}`).diff(moment(`${this.job.public.startDate}`), 'minutes') < 0 ? new Date(moment(this.job.public.endDate).add(1, 'month')).toISOString().slice(0, 10) : this.job.public.contractEndDate
      if (this.job.public.repeat === this.$language.addJob['Custom...']) {
        this.job.public.endDate = this.job.public.startDate
      }
      // this.job.public.occ.weekOfMonth = Math.ceil((moment(this.job.public.startDate).day()).date() / 7)
    },
    'job.public.startDate': function () {
      this.job.public.endDate = this.job.public.startDate
    },
    'job.public.category': function () {
      this.job.public.title = `${this.job.public.category} work`
    }

  },
  mounted: function () {
    this.$nextTick(() => {
      this.showCroppa = true
    })
    this.job.public.category = this.$route.query.type
    this.job.public.title = `${this.$route.query.type} work`
  },
  filters: {

    formatDateTime (val) {
      if (!val) {
        return '-'
      }
      let date = new Date(val)
      return moment(date).fromNow()
    },
    formatTime (val) {
      if (!val) {
        return '-'
      }
      return moment(val, ['HH.mm']).format('hh:mm a')
    }
  }
}
</script>

<style scoped>
.theme--light.v-text-field--outline > .v-input__control > .v-input__slot {
  border: 2px solid #bdbdbd !important;
  border-radius: 5px;
  padding-left: 10px !important;
}

.theme--light.v-text-field--outline > .v-input__control > .v-input__slot:hover {
  border: 2px solid #bdbdbd !important;
}

/*.croppa-container {
  width: calc(100vw - 40px);
  max-width: 840px !important;
  height: 200px;
  margin: 0 auto;
  display: block;
}*/

.no-padding-hint > .v-input__control > .v-text-field__details {
  padding: 0px !important;
  margin: 0px !important;
}

.scrollable {
  overflow-y: auto;
}

.custom-input {
  border: 0.5px solid;
  border-color: grey;
}
.active {
  border: 0.5px solid;
  border-color: #ff5722;
}
.centered-input input {
  text-align: end;
}
</style>

// TIME PICKER
<style>
.vue__time-picker {
  display: inline-block;
  position: relative;
  font-size: 1em;
  width: 7em;

  font-family: sans-serif;
  vertical-align: middle;
}
.vue__time-picker * {
  box-sizing: border-box;
}
.vue__time-picker input.display-time {
  border: 1px solid grey;
  border-radius: 5px;
  width: 7em;
  height: 40px;
  padding: 0.3em 0.5em;
  font-size: 1em;
}
.dark {
  color: white;
}
.vue__time-picker input.has-custom-icon {
  padding-left: 2em;
}
.vue__time-picker input.display-time.invalid:not(.skip-error-style) {
  border-color: #ff5722;
  outline-color: #ff5722;
}
.vue__time-picker input.display-time:disabled,
.vue__time-picker input.display-time.disabled {
  color: #d2d2d2;
}
.vue__time-picker .controls {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 3;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: stretch;
  /* Prevent browser focusing on the controls layer */
  pointer-events: none;
}
.vue__time-picker .controls > * {
  cursor: pointer;

  width: auto;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  padding: 0 0.35em;
  color: #d2d2d2;
  line-height: 100%;
  font-style: normal;
  /* Resume pointer-events on children components */
  pointer-events: initial;
  transition: color 0.2s, opacity 0.2s;
}
.vue__time-picker .controls > *:hover {
  color: #797979;
}
.vue__time-picker .controls > *:focus,
.vue__time-picker .controls > *:active {
  outline: 0;
}
.vue__time-picker .controls .char {
  font-size: 1.1em;
  line-height: 100%;
  /* Vertical align fixes for webkit browsers only */
  -webkit-margin-before: -0.15em;
}
.vue__time-picker .custom-icon {
  z-index: 2;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 1.8em;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  /* pass down mouse events to the <input> underneath */
  pointer-events: none;
}
.vue__time-picker .custom-icon img,
.vue__time-picker .custom-icon svg,
.vue__time-picker .controls img,
.vue__time-picker .controls svg {
  display: inline-block;
  vertical-align: middle;
  margin: 0;
  border: 0;
  outline: 0;
  max-width: 1em;
  height: auto;
}
.vue__time-picker .time-picker-overlay {
  z-index: 4;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.vue__time-picker .dropdown {
  position: absolute;
  z-index: 5;
  /* top: calc(2.2em + 2px); */
  left: -25px;
  background: #fff;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.15);
  width: 10em;
  height: 10em;
  font-weight: normal;
}
.vue__time-picker .dropdown.drop-up {
  top: auto;
  bottom: calc(2.2em + 1px);
}
.vue__time-picker .dropdown .select-list {
  width: 10em;
  height: 10em;
  overflow: hidden;
  display: flex;
  flex-flow: row nowrap;
  align-items: stretch;
  justify-content: space-between;
}
.vue__time-picker .dropdown .select-list:focus,
.vue__time-picker .dropdown .select-list:active {
  outline: 0;
}
.vue__time-picker .dropdown ul {
  padding: 0;
  margin: 0;
  list-style: none;
  outline: 0;
  flex: 1 1 0.00001px;
  overflow-x: hidden;
  overflow-y: auto;
}
.vue__time-picker .dropdown ul.minutes,
.vue__time-picker .dropdown ul.seconds,
.vue__time-picker .dropdown ul.apms {
  border-left: 1px solid #fff;
}
.vue__time-picker .dropdown ul li {
  list-style: none;
  text-align: center;
  padding: 0.3em 0;
  color: #161616;
}
.vue__time-picker .dropdown ul li:not(.hint):not([disabled]):hover,
.vue__time-picker .dropdown ul li:not(.hint):not([disabled]):focus {
  background: rgba(0, 0, 0, 0.08);
  color: #161616;
  cursor: pointer;
}
.vue__time-picker .dropdown ul li:not([disabled]).active,
.vue__time-picker .dropdown ul li:not([disabled]).active:hover,
.vue__time-picker .dropdown ul li:not([disabled]).active:focus {
  background: #41b883;
  color: #fff;
}
.vue__time-picker .dropdown ul li[disabled],
.vue__time-picker .dropdown ul li[disabled]:hover {
  background: transparent;
  opacity: 0.3;
  cursor: not-allowed;
}
.vue__time-picker .dropdown .hint {
  color: #a5a5a5;
  cursor: default;
  font-size: 0.8em;
}
</style>
